<template>
  <section>
    <h4 class="h4 text--bold text--uppercase">Sobre la relación animales silvestres-ganado</h4>
    <form-group :error="errors.has('mamiferos-frecuentes') && submitted">
      <label class="form__label form__label--required">
        32. ¿Cuáles son los dos mamíferos silvestres que se ven con mayor frecuencia en su finca?
      </label>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.mamiferosFrecuentes"
        id="tepezcuintle"
        name="mamiferos-frecuentes"
        v-validate="'required'"
        value="Tepezcuintle">
        <label class="form__label" for="tepezcuintle">Tepezcuintle</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.mamiferosFrecuentes"
        id="saino"
        name="mamiferos-frecuentes"
        v-validate="'required'"
        value="Saíno (de collar)">
        <label class="form__label" for="saino">Saíno (de collar)</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.mamiferosFrecuentes"
        id="chancho-monte"
        name="mamiferos-frecuentes"
        v-validate="'required'"
        value="Chancho de monte (cariblanco">
        <label class="form__label" for="chancho-monte">Chancho de monte (cariblanco)</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.mamiferosFrecuentes"
        id="danta-tapir"
        name="mamiferos-frecuentes"
        v-validate="'required'"
        value="Danta/tapir">
        <label class="form__label" for="danta-tapir">Danta/tapir</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.mamiferosFrecuentes"
        id="cabro-monte"
        name="mamiferos-frecuentes"
        v-validate="'required'"
        value="Cabro de monte">
        <label class="form__label" for="cabro-monte">Cabro de monte</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.mamiferosFrecuentes"
        id="venado"
        name="mamiferos-frecuentes"
        v-validate="'required'"
        value="Venado cola blanca">
        <label class="form__label" for="venado">Venado cola blanca</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.mamiferosFrecuentes"
        id="puma-leon1"
        name="mamiferos-frecuentes"
        v-validate="'required'"
        value="Puma/león">
        <label class="form__label" for="puma-leon1">Puma/león</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.mamiferosFrecuentes"
        id="jaguar-tigre-pantera1"
        name="mamiferos-frecuentes"
        v-validate="'required'"
        value="Jaguar/tigre/pantera">
        <label class="form__label" for="jaguar-tigre-pantera1">Jaguar/tigre/pantera</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.mamiferosFrecuentes"
        id="otro-mamifero-frecuente"
        name="mamiferos-frecuentes"
        v-validate="'required'"
        value="Otro">
        <label class="form__label" for="otro-mamifero-frecuente">
          Otro / Comentarios adicionales
        </label>
      </div>
    </form-group>

    <div class="identado">
      <form-group :error="errors.has('otro-mamifero') && submitted"
      v-if="form.mamiferosFrecuentes.includes('Otro')">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.otroMamiferosMayFrec"
        name="otro-mamifero"
        required
        v-validate="'required'">
        <label class="form__label">
          Especifique cual otro:
        </label>
      </form-group>
    </div>

    <form-group :error="errors.has('hayCaceria') && submitted">
      <label class="form__label form__label--required">
        33. ¿Se da cacería o montean en la zona?
        </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        name="hayCaceria"
        id="dentro-finca"
        v-model="form.hayCaceria"
        value="Dentro de la finca"
        v-validate="'required'">
        <label class="form__label" for="dentro-finca">Dentro de la finca</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        name="hayCaceria"
        id="alrededor-finca"
        v-model="form.hayCaceria"
        value="Alrededor de la finca (fincas vecinas)"
        v-validate="'required'">
        <label class="form__label" for="alrededor-finca">Alrededor de la finca (fincas vecinas)
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        name="hayCaceria"
        id="no-hay-caceria"
        v-model="form.hayCaceria"
        value="No hay cacería"
        v-validate="'required'">
        <label class="form__label" for="no-hay-caceria">No hay cacería</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        name="hayCaceria"
        id="nsnr"
        v-model="form.hayCaceria"
        value="NS/NR"
        v-validate="'required'">
        <label class="form__label" for="nsnr">NS/NR</label>
      </div>
    </form-group>

    <form-group :error="errors.has('animales-problematicos') && submitted">
      <label class="form__label form__label--required">
        34. Los animales silvestres que a veces le causan problemas a su ganado son
      </label>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.animalesProblematicos"
        id="serpientes-problema"
        name="animales-problematicos"
        v-validate="'required'"
        value="Serpientes">
        <label class="form__label" for="serpientes-problema">Serpientes</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.animalesProblematicos"
        id="vampiros-problema"
        name="animales-problematicos"
        v-validate="'required'"
        value="Vampiros">
        <label class="form__label" for="vampiros-problema">Vampiros</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.animalesProblematicos"
        id="coyote-problema"
        name="animales-problematicos"
        v-validate="'required'"
        value="Coyote">
        <label class="form__label" for="coyote-problema">Coyote</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.animalesProblematicos"
        id="ocelote-problema"
        name="animales-problematicos"
        v-validate="'required'"
        value="Ocelote/manigordo">
        <label class="form__label" for="ocelote-problema">Ocelote/manigordo</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.animalesProblematicos"
        id="cabro-monte-problema"
        name="animales-problematicos"
        v-validate="'required'"
        value="Cabro de monte">
        <label class="form__label" for="cabro-monte-problema">Cabro de monte</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.animalesProblematicos"
        id="venado-problema"
        name="animales-problematicos"
        v-validate="'required'"
        value="Venado cola blanca">
        <label class="form__label" for="venado-problema">Venado cola blanca</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.animalesProblematicos"
        id="puma-leon-problema"
        name="animales-problematicos"
        v-validate="'required'"
        value="Puma/león">
        <label class="form__label" for="puma-leon-problema">Puma/león</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.animalesProblematicos"
        id="jaguar-problema"
        name="animales-problematicos"
        v-validate="'required'"
        value="Jaguar/tigre/pantera">
        <label class="form__label" for="jaguar-problema">Jaguar/tigre/pantera</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.animalesProblematicos"
        id="ningun-animal"
        name="animales-problematicos"
        v-validate="'required'"
        value="Ninguno">
        <label class="form__label" for="ningun-animal">Ninguno</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.animalesProblematicos"
        id="otro-animal-problematico"
        name="animales-problematicos"
        v-validate="'required'"
        value="Otro">
        <label class="form__label" for="otro-animal-problematico">
          Otro / Comentarios adicionales
        </label>
      </div>
    </form-group>

    <div class="identado">
      <form-group
      v-if="includes(form.animalesProblematicos, 'Otro')"
      :error="errors.has('nombre-otro-animal-problematico') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.animalesProblematicosOtro"
        name="nombre-otro-animal-problematico"
        required
        v-validate="'required'">
        <label class="form__label">Indique cuál</label>
      </form-group>
    </div>

  </section>
</template>

<script>
import includes from "lodash/includes";

export default {
  name: "FormGanadoBloque3",
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
    includes,
  },
};

function validar() {
  return this.$validator.validate();
}
</script>
